export const PATH = {

    MY_PROFILE: "/profile",

    DASHBOARD: "/dashboard",

    ORDERS: "/orders",
    CREATE_ORDER: "/create-order",
    UPDATE_ORDER: "/update-order",

    KITS: "/kits",

    BATCHES: "/batches",
    CREATE_BATCH: "/create-batch",
    UPDATE_BATCH: "/update-batch",
    LIST_OF_BARCODES: "/list-of-barcodes",
    CREATE_SAMPLE: "/create-sample",
    SAMPLE_HISTORY: "/history-of-sample",

    DEIDENTIFIED_DATA: "/deidentified-data",


    DATA_ANALYSIS: "/data-analysis",
    BIOINFORMATICS: "/bioinformatics",
    SAMPLES_BIOINFORMATICS: "/samples-bioinformatics",
    ML_ANALYSIS: "/ml-analysis",
    SAMPLES_ML_ANALYSIS: "/samples-ml-analysis",
    R_ANALYSIS: "/r-analysis",
    SAMPLES_R_ANALYSIS: "/samples-r-analysis",
    REPORT_GENERATION: "/report-generation",
    SAMPLES_REPORT_GENERATION: "/samples-report-generation",
    QUALITY_CONTROL: "/quality-control",
    SAMPLES_QUALITY_CONTROL: "/samples-quality-control",

    METADATA: "/metadata",

    STUDY_AND_ANALYSIS: "/study-and-analysis",

    PRODUCTS: "/management/products",
    CREATE_PRODUCTS: "/products/create-products",
    UPDATE_PRODUCTS: "/products/update-products",

    CLIENTS: "/clients",
    CREATE_CLIENT: "/create-client",
    UPDATE_CLIENT: "/update-client",

    SCRIPTS: "/scripts",
    UPLOAD_SCRIPT: "/upload-script",
    SCRIPT_HISTORY: "/history-of-script",

    MANAGEMENT: "/management",

    USERS: "/management/users",
    CREATE_USER: "/management/create-user",
    UPDATE_USER: "/management/update-user",

    ROLES: "/management/roles",
    UPDATE_ROLE_PERMISSION: "/management/update-screen-permission",

    AUDIT_LOG: "/management/audit-log",


    REPORT_TEMPLATE: "/report-templates",
    CREATE_REPORT_TEMPLATE: "/report-templates/create-report-template",
    UPDATE_REPORT_TEMPLATE: "/report-templates/update-report-template",
    REPORT_TEMPLATE_HISTORY: "/report-templates/history-of-report-template",

    DATA_CURATION: "/data-curation",
    UPLOAD_DATA_CURATION: "/upload-data-curation",
    DATA_CURATION_HISTORY: "/data-curation/history-of-data-curation",

    FREEZER: "/-80-freezer",
    LAB_CONSUMABLES: "/lab-consumables",
    HISTORY_OF_LAB_CONSUMABLES: "/lab-consumables/history-of-lab-consumables",
    GUTCHECK_SUPPLIES: "/gutcheck-supplies",
    HISTORY_OF_GUTCHECK_SUPPLIES: "/gutcheck-supplies/history-of-gutcheck-supplies",


}